import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer: React.FC = () => {
    return (
        <Box
            component="footer"
            sx={{
                width: '100%',
                bgcolor: '#1e90ff',
                height: '10vh', // Set height to 10% of the viewport height
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderTop: '1px solid #e0e0e0', // Optional border at the top
                position: 'sticky', // Keep it at the bottom of the page
                bottom: 0, // Stick to the bottom of the viewport
            }}
        >
            <Typography
                variant="body2"
                color="text.primary"
                sx={{
                    fontFamily: 'Jancient, sans-serif',
                    textAlign: 'center',
                }}
            >
                © {new Date().getFullYear()} American Polling Machine, LLC. All rights reserved.{' '}
                <Link href="/privacy-policy" color="inherit" sx={{ textDecoration: 'underline' }}>
                    Privacy Policy
                </Link>
            </Typography>
        </Box>
    );
};

export default Footer;
